import { computed } from 'vue';
import { useComponentContext } from 'composables/useComponentContext';
import { useStateStore } from 'composables/useStateStore';

const ACCORDION_TYPE = 'Accordion';
const ACCORDION_ITEM_TYPE = 'AccordionItem';

export const useAccordion = () => {
  const context = useComponentContext();
  const stateStore = useStateStore<any>();

  // Find the correct accordion UID
  let accordionUid: number | null | undefined = null;
  if (context.typeName === ACCORDION_TYPE) {
    accordionUid = context.uid;
  } else {
    const parentAccordion = stateStore.findParentOfType(context.uid as number, ACCORDION_TYPE);
    accordionUid = parentAccordion?.uid;
  }

  // Find all child accordion items for this accordion
  const items = computed(() => (accordionUid ? stateStore.findChildren(accordionUid) : []));

  // Helper to resolve itemUid
  function resolveItemUid(itemUid?: number): number | null {
    if (itemUid) return itemUid;

    if (context.typeName === ACCORDION_ITEM_TYPE) return context.uid;

    // Find nearest parent AccordionItem
    const parentItem = stateStore.findParentOfType(context.uid as number, ACCORDION_ITEM_TYPE);
    if (parentItem?.uid) return parentItem.uid;

    throw new Error(
      'No itemUid provided and not called from or inside an AccordionItem component.'
    );
  }

  // Controller functions
  const open = (itemUid?: number) => {
    const uid = resolveItemUid(itemUid);
    stateStore.setPropValue(Number(uid), 'open', true);
  };

  const close = (itemUid?: number) => {
    const uid = resolveItemUid(itemUid);
    stateStore.setPropValue(Number(uid), 'open', false);
  };

  const toggle = (itemUid?: number) => {
    console.log('Toggling accordion item:', itemUid);
    const uid = resolveItemUid(itemUid);
    const item = stateStore.getByUid(Number(uid));
    if (item) {
      console.log('Current open state:', item.props.open);
      stateStore.setPropValue(Number(uid), 'open', !item.props.open);
    }
  };

  const isOpen = (itemUid?: number) => {
    const uid = resolveItemUid(itemUid);
    const item = stateStore.getByUid(Number(uid));
    return item ? !!item.props.open : false;
  };

  return {
    items,
    open,
    close,
    toggle,
    isOpen,
    accordionUid
  };
};
